<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<p-toast />
<div class="ab-container-full" *ngIf="router.url.split('/')[1] === '' || router.url.split('/')[1] === '?isUrlc=true'">
  <div class="global-top-strip">
    <div class="global-strip-banner-message">
      <!-- <div class="col wt-block">
      </div> -->
      <div class="col wt-block py-0">
        <p class=" m-auto">In Delhi-NCR <span
            style=" font-size: 14px;font-family: 'SF UI Text Regular';pointer-events: none;position: inherit;letter-spacing: 1px;">Stay tuned
          </span>
        </p>
      </div>
      <div class="col wt-block py-0">
        <p style="text-align: right;">Reach us at -<a href="tel:+918800909063" title="8800909063"> 8800909063</a>

        </p>
      </div>
      <div class="col m-block py-0">
        <div class="d-flex justify-content-between">
          <div>
            <p class="d-flex w-100 py-0"> <span>In Delhi-NCR</span></p>
          </div>
          <div>
            <p>
              <span>Reach us: <a href="tel:+918800909063" title="8800909063"> 8800909063</a> </span>
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- </div> -->
<div class="ab-full-width" [ngClass]="{'ab-full-wdth-shadow':!_ds.isMegaMenu}" *ngIf="isBrowser">
  <div class="ab-navbar-strip">
    <div class="navbar navbar-expand-lg navbar-dark p-0">
      <div class="nav-col-first">
        <i (click)="onMegaMenuMobile()" class="fa-solid fa-bars"></i>
        <a class="ab-logo"  routerLink=""  title="Home">
          <img ngOptimizedImage width="160" height="36"  src="assets/images/afterbricks-logo.jpg" alt="afterbricks" loading="lazy">
          <!-- <button class="beta-btn-new" *ngIf="onSmartView()">BETA</button> -->
        </a>
        <div class="w-block vertical-border" *ngIf="!_as.isLoginPage"></div>
        <div class=" w-block nav-col-middle-one" *ngIf="isBrowser">
          <div class="location">
            <div class="user-location-icon-address">
              <div class="user-location-icon-address-img" (click)="locationService.onLocation()">
                <svg width="1.8rem" height="1.8rem" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle opacity="0.2" cx="20" cy="20" r="20" fill="#FC9918" />
                  <path
                    d="M28 18.7287C28 14.4455 24.3333 11 20 11C15.5665 11 12 14.4457 12 18.7287V19.0508C12 19.083 12.1333 20.2101 12.2667 20.6931C13.2 24.4611 16.3665 27.327 20 30C23.6333 27.3271 26.8 24.4611 27.7333 20.6931C27.8667 20.2101 28 19.1152 28 19.0508V18.7287ZM20 21.949C18.1667 21.949 16.6667 20.4999 16.6667 18.7287C16.6667 16.9576 18.1667 15.5084 20 15.5084C21.8333 15.5084 23.3333 16.9576 23.3333 18.7287C23.3333 20.4999 21.8333 21.949 20 21.949Z"
                    fill="#FC9918" />
                </svg>
              </div>
              <div class="d-flex align-items-center" style="max-width: 135px;">
                <div class="title pr-2 d-grid">Location
                  <span class="location-span" *ngIf="!_as.user_location" (click)="locationService.onLocation()">Select your location</span>
                  <div class="location-span" *ngIf="_as.user_location" (click)="locationService.onLocation()"
                    style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"> <span *ngIf="_as.user_location.locality">{{_as.user_location.locality}},<br></span>
                    {{_as.user_location.city}}</div>
                </div>
              </div>
              <div class="location-pop" [ngClass]="{'active-location-pop':_as.locationPop}">
                <div class="location-pop-overley-mask" (click)="onShake()">
                </div>
                <div class="location-body" [ngClass]="{'active-location-body':_as.locationPop,'skew-shake-x':isShake}"
                  >
                  <div class="location-loader-container" *ngIf="locationService.isLoctionLoader">
                  </div>
                  <div>
                    <img ngOptimizedImage class="close-img" *ngIf="_as.user_location?.city" src="assets/images/icons/closeicon.png"
                      alt="close" (click)="locationService.closeChangeLocation()" loading="lazy">
                    <p class="location-heding" *ngIf="!_as.user_location?.city">Welcome to afterbricks</p>
                    <p *ngIf="_as.user_location?.city ">Your home location</p>
                    <div class="location-body-content" *ngIf="!_as.user_location?.city">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="0.2" cx="20" cy="20" r="20" fill="#FC9918" />
                        <path
                          d="M28 18.7287C28 14.4455 24.3333 11 20 11C15.5665 11 12 14.4457 12 18.7287V19.0508C12 19.083 12.1333 20.2101 12.2667 20.6931C13.2 24.4611 16.3665 27.327 20 30C23.6333 27.3271 26.8 24.4611 27.7333 20.6931C27.8667 20.2101 28 19.1152 28 19.0508V18.7287ZM20 21.949C18.1667 21.949 16.6667 20.4999 16.6667 18.7287C16.6667 16.9576 18.1667 15.5084 20 15.5084C21.8333 15.5084 23.3333 16.9576 23.3333 18.7287C23.3333 20.4999 21.8333 21.949 20 21.949Z"
                          fill="#FC9918" />
                      </svg>
                      <p>Please provide your house location to see products at nearby dealer showroom</p>
                    </div>

                    <div class="location-body-btn wwww" *ngIf="!_as.user_location?.city">
                      <button class="btn btn-primary" (click)="locationService.getCurrentLocation()" title="Get my location">
                        <i  *ngIf="locationService.isLoctionLoader" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        Get my location</button>
                      <!-- <button class="btn btn-primary" style="pointer-events: none;"
                        *ngIf="locationService.isLoctionLoader"><i
                          class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></button> -->

                      <div class="or-circul">
                        <p>or</p>
                      </div>
                      <div>
                        <div id="usergmap" class="modalmap"></div>
                        <input id="pac-input" class="controls pac-inputcss" type="text"
                          placeholder="Some other Location">
                      </div>

                    </div>
                    <div class="location-body-content" *ngIf="_as.user_location?.city && !_as.isUpdateLocation">
                      <img ngOptimizedImage src="assets/images/icon/map-icon.png" alt="map-icon">
                      <h3><span *ngIf="_as.user_location.locality">{{_as.user_location.locality}},</span> {{_as.user_location.city}}</h3>
                      <button class="btn btn-success" (click)="locationService.updateLocation()" title="Change">Change</button>
                    </div>
                    <div class="location-body-btn" *ngIf="_as.user_location?.city && _as.isUpdateLocation">
                      <button class="btn btn-primary" (click)="locationService.getCurrentLocation()" title="Get my location"
                       ><i  *ngIf="locationService.isLoctionLoader" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        Get my location</button>
                      <div class="or-circul">
                        <p>or</p>
                      </div>
                      <div>
                        <div id="usergmap" class="modalmap"></div>
                        <input id="pac-input" class="controls pac-inputcss" type="text"
                          placeholder="Some other Location">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="nav-col-middle" *ngIf="!_as.isLoginPage && isBrowser">
        <div class="wt-block w-100" *ngIf="getTabStatus()">
          <div class="globle-search">
            <div class="search-input-box">
              <input type="text" class="seach-input" [(ngModel)]="_ss.query" (keyup)="newGlobleSearch(_ss.query)" id="dynamic-placeholder"
              [appSuperPlaceholder]="_ss.placeholder_samples" (keyup.enter)="onSearchSmartview()" (focus)="focusSuggetionpup()" (focusout)="focusOutSuggetionpup()">
              <div class="search-icon" (click)="onSearchSmartview()">
                <button type="submit"><i class="pi pi-arrow-circle-up "></i></button>
              </div>
            </div>
            <!-- *ngIf="isSuggetionPopUp && getSuggetionStatus()" -->
            <div class="search-suggestions-popup"  *ngIf="isSuggetionPopUp && getSuggetionStatus()">
              
                <div class="suggestion-box">
                  <div class="sug_items" *ngIf="sug_product_types?.length">
                    <span class="sug-items-head">{{getProductTypeHeading(sug_product_types)}}</span>
                    <ul class="ug-items">
                      <li *ngFor="let pt of sug_product_types">
                       
                        <a class="suggestion-link" (click)="onTypeLink(pt?.main_category_slug_name,pt.sub_category_id,pt.id)">
                          <div class="img-box" *ngIf="pt?.type_icon">
                            <img ngOptimizedImage [src]="pt?.type_icon" [alt]="pt?.name">
                          </div>
                          
                          <span>{{pt?.name}}</span>
                        </a>
                      </li>
                    </ul>
                   </div>
                 <div class="sug_items" *ngIf="sug_sub_categories?.length">
                  <span class="sug-items-head">{{getcategoryHeading(sug_sub_categories)}}</span>
                  <ul class="ug-items">
                    <li *ngFor="let sub of sug_sub_categories">
                      <a class="suggestion-link" (click)="onCategoryLink(sub?.main_category_slug_name,sub?.name_slug)" >
                        <div class="img-box">
                          <img ngOptimizedImage [src]="sub?.category_icon" [alt]="sub?.name">
                        </div>
                        
                        <span>{{sub?.name}}</span>
                      </a>
                    </li>
                  </ul>
                 </div>
                 <div class="sug_items" *ngIf="sug_brands?.length">
                  <span class="sug-items-head">{{getBrandHeding(sug_brands)}}</span>
                  <ul class="ug-items">
                    <li *ngFor="let brand of sug_brands">
                      <a class="suggestion-link"  (click)="onBrandLink(brand?.slug_name)">
                        <div class="img-box">
                          <img ngOptimizedImage [src]="brand?.icon" [alt]="brand?.brand_name">
                        </div>
                        <span>{{brand?.brand_name}}</span>
                      </a>
                    </li>
                  </ul>
                 </div>
                </div>
                <div class="suggestion-box-sec2">
                <div class="suggestion-box-products " *ngIf="sug_products?.length">
                  <a class="sug-products " (click)="onProductDetail(prod)" *ngFor="let prod of sug_products">
                    <div class="sug-p-img">
                      <img ngOptimizedImage [src]="prod?.images[0]?.image" [alt]="prod?.name">
                    </div>
                    <div class="sug-p-text">
                      <p>{{prod?.name}}</p>
                      <span></span>
                      <div class="amout" *ngIf="prod?.effective_price">&#8377; {{prod?.effective_price | number:'1.0-1'}}</div>
                    </div>
                  </a>
                </div>
              </div>
             
             
           </div>
          </div>
        </div>
      </div>
      <div class="nav-col-last" *ngIf="!_as.isLoginPage && isBrowser">
        <ul class="top-manu">
          <li class=" py-0 my-auto project-card project-cl wt-block" *ngIf="_as.isUserLoggedIn && getShowStatus()">
            <span
              *ngIf="(_project.selectedProject && !_project.selectedProject?.is_assigned) || _as.user_info?.is_service_provider">Active
              Project</span>
            <!-- <span *ngIf="_project.selectedProject && (_project.selectedProject?.is_assigned && _as.user_info?.is_service_provider)">Assigned Project</span> -->
            <span
              *ngIf="_project.selectedProject && _project.selectedProject?.is_assigned && !_as.user_info?.is_service_provider">Service
              Provider</span>
            <a *ngIf="_project.selectedProject?.name  && _project.selectedProject?.id && _project.selectedProject?.is_assigned && !_as.user_info?.is_service_provider"
              (click)="_project.onDisplayProjects(true)" [title]="_project.selectedProject?.name">
              {{_project.selectedProject?.service_provider?.name}}</a>
            <a *ngIf="(_project.selectedProject?.name  && _project.selectedProject?.id && !_project.selectedProject?.is_assigned) || _as.user_info?.is_service_provider"
              (click)="_project.onDisplayProjects(true)" [title]="_project.selectedProject?.name">
              {{_project.selectedProject?.name}}</a>
            <a *ngIf="!_project.selectedProject?.name && _project.selectedProject?.id"
              (click)="_project.onDisplayProjects(true)">Project {{_project.selectedProject?.id}}</a>
            <a *ngIf="!_project.selectedProject?.name && !_project.selectedProject?.id"
              (click)="_project.onDisplayProjects(true)">Select Project</a>

          </li>
       
          <li *ngIf="_as?.isUserLoggedIn"  [ngClass]="{'d-none':safePathCheck()=='saved-ideas'}">
            <!-- [ngClass]="{'d-none':_as.isOnMobilePlatform && _location.path().split('/')[1]=='product'}" -->
            <a class="nav-item" tooltipPosition="bottom" pTooltip="Saved Ideas" (click)="onSaveIdea()">
              <i class="fa-solid fa-heart"></i>
              <span class="badge"
                *ngIf="_as.isUserLoggedIn && _project.cart_data?.save_indea_product_count">{{_project.cart_data?.save_indea_product_count}}</span>
            </a>
          </li>
          <!-- <li
            *ngIf="_as?.isUserLoggedIn && (!_project.selectedProject?.is_assigned || _as.user_info?.is_service_provider) && (_project.cart_data?.cart_product_count || _project.cart_data?.compare_offer_count)"
            [ngClass]="{'d-none':(_as.isOnMobilePlatform && safePathCheck()=='product') || safePathCheck()=='my-list'}">
            <a class="nav-item" (click)="onCart()" pTooltip="My List" tooltipPosition="bottom">
              <i class="fa-solid fa-clipboard-list"></i>
              <span class="badge"
                *ngIf="_as.isUserLoggedIn && _project.cart_data?.cart_product_count">{{_project.cart_data?.cart_product_count}}</span>
            </a>
          </li> -->
          <li
            *ngIf="!_project.selectedProject?.is_assigned && _as.isUserLoggedIn "
            [ngClass]="{'d-none':safePathCheck()=='cart'}">
            <a class="nav-item" (click)="onNewCart()" pTooltip="My List" tooltipPosition="bottom">
              <i class="fa-solid fa-cart-shopping" ></i>
              <span class="badge"
                *ngIf="_as.isUserLoggedIn && _project.cart_data?.cart_product_count">{{_project.cart_data?.cart_product_count}}</span>
            </a>
          </li>
          <li *ngIf="_as.isUserLoggedIn ">
            <a class="nav-item" pTooltip="Notifications"
              *ngIf="!_project.selectedProject?.is_assigned || _as.user_info.is_service_provider"
              tooltipPosition="bottom" (click)="onNotification()">
              <i class="fa-solid fa-bell"></i>
              <span class="badge"
                *ngIf="_as.isUserLoggedIn && _as.user_info?.noticount">{{_as.user_info?.noticount}}</span>
            </a>
          </li>

          <li *ngIf="_as.isUserLoggedIn">
            <a class="profile" (click)="openProfileright()">
              <div class="profile-img">
                <span class="m-block user-first-alp"
                  *ngIf="!_as.user_info?.userProfile?.image && loggedInUsername !==undefined">{{loggedInUsername |
                  uppercase}}</span>
                <i class="fa-solid fa-user" *ngIf="!_as.user_info?.userProfile?.image && !loggedInUsername"></i>
                <img ngOptimizedImage src="{{_as.user_info?.userProfile?.image}}" [alt]="_as.user_info?.userProfile?.username"
                  *ngIf="_as.user_info?.userProfile?.image" loading="lazy">
              </div>
              <span class="wt-block"
                *ngIf="_as.user_info?.userProfile?.username">{{_as.user_info?.userProfile?.username}}</span>
              <span class="wt-block" *ngIf="_as.isUserLoggedIn && !_as.user_info?.userProfile?.username">My
                Account</span>
            </a>
          </li>
          <li class="smart-view-link" *ngIf="!_as.isUserLoggedIn && !_as.isOnMobilePlatform && !onSmartView()">
            
<svg xmlns="http://www.w3.org/2000/svg" width="15" height="36" viewBox="0 0 12 16" fill="none" aria-hidden="true">
  <path d="M6.65723 6.24707C6.76704 5.91764 7.233 5.91765 7.34281 6.24707L7.98828 8.1835C8.276 9.04666 8.95332 9.72399 9.81648 10.0117L11.7529 10.6572C12.0824 10.767 12.0824 11.233 11.7529 11.3428L9.81649 11.9883C8.95332 12.276 8.27599 12.9533 7.98828 13.8165L7.34281 15.7529C7.233 16.0823 6.76704 16.0823 6.65723 15.7529L6.01173 13.8165C5.72401 12.9533 5.04669 12.276 4.18353 11.9883L2.24707 11.3428C1.91764 11.233 1.91764 10.767 2.24707 10.6572L4.18353 10.0117C5.04669 9.72399 5.72401 9.04667 6.01173 8.18352L6.65723 6.24707Z" fill="#9763f6"></path>
  <path d="M2.79434 1.14824C2.86023 0.950586 3.1398 0.950587 3.20569 1.14824L3.59297 2.3101C3.7656 2.828 4.172 3.2344 4.6899 3.40703L5.85177 3.79432C6.04942 3.86021 6.04942 4.13978 5.85177 4.20567L4.6899 4.59296C4.172 4.76559 3.7656 5.17199 3.59297 5.68989L3.20569 6.85176C3.13981 7.04941 2.86023 7.04942 2.79434 6.85176L2.40704 5.68988C2.23441 5.17198 1.82801 4.76559 1.31012 4.59296L0.148241 4.20567C-0.0494137 4.13978 -0.0494138 3.86021 0.148241 3.79432L1.31012 3.40703C1.82802 3.2344 2.23441 2.82801 2.40704 2.31011L2.79434 1.14824Z" fill="#9763f6"></path>
  <path d="M9.8629 0.0988265C9.90682 -0.032943 10.0932 -0.0329419 10.1371 0.098828L10.3953 0.873401C10.5104 1.21867 10.7813 1.4896 11.1266 1.60469L11.9012 1.86288C12.0329 1.9068 12.0329 2.09319 11.9012 2.13711L11.1266 2.39531C10.7813 2.51039 10.5104 2.78133 10.3953 3.12659L10.1371 3.90117C10.0932 4.03294 9.90682 4.03294 9.8629 3.90117L9.6047 3.12659C9.48961 2.78132 9.21868 2.5104 8.87342 2.39531L8.09883 2.13711C7.96706 2.09319 7.96706 1.9068 8.09883 1.86288L8.87342 1.60469C9.21868 1.4896 9.48961 1.21867 9.6047 0.873408L9.8629 0.0988265Z" fill="#9763f6"></path>
</svg>

            <a routerLink="../smart-search" [queryParams]="{q:''}"> 
              
              Smart Search 
            </a>
          </li>
          <li class="login-btn" *ngIf="!_as.isUserLoggedIn">
            <a title="Log In" (click)="_as.onLoginPage()">
              <span>Log In</span>
            </a>
          </li>
          <li class="login-btn joinaspro" *ngIf="!_as.isUserLoggedIn">
            <a title="Join as Pro"  href="{{_as.subscribeUrl}}/home" target="_blank">
              <span>Join as Pro </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="ab-full-width" *ngIf="!isBrowser">
  <div class="ab-navbar-strip">
    <a class="ab-logo"  routerLink=""  title="Home">
      <img ngOptimizedImage width="160" height="36"  src="assets/images/afterbricks-logo.jpg" alt="afterbricks" loading="lazy">
      <!-- <button class="beta-btn-new" *ngIf="onSmartView()">BETA</button> -->
    </a>
  </div>
</div>
<div class="ab-container-full wt-block bg-white top-sticky top-department-menu" *ngIf="_ds.isMegaMenu && !isBrowser"></div>
<!---------------------------- Start-Megamenu-Code ------------------------->
<div class="ab-container-full w-block bg-white top-sticky top-department-menu" *ngIf="_ds.isMegaMenu && isBrowser">
  <div class=" pm-0" [ngClass]="{'top-fixid':is_pageup_button}" *ngIf="!_ds.isDepartmentLoader && !_as.isLoginPage">
    <div id="top-menu-section" class="container-fluid">     
      <div class=" justify-content-start  ab-container-full position-relative">
        <app-mega-menu></app-mega-menu>
      </div>
    </div>
  </div>
</div>
<!---------------------------- End-Megamenu-Code ------------------------->

<div class="m-block bg-white pb-2" *ngIf="isBrowser && hideSection()">
  <!-----------------------Mobile location ------------------>

  <div class="location" style="justify-content: flex-start; background-color: F6F6F6;" *ngIf="!_as.isLoginPage">
    <svg *ngIf="!_as.user_location" style="margin-right: 8px;height:20px;" width="20" height="25" viewBox="0 0 20 25"
      fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 10.1694C20 4.53361 15.4167 0 10 0C4.4581 0 0 4.53385 0 10.1694V10.5931C0 10.6355 0.166667 12.1185 0.333333 12.7541C1.5 17.7119 5.4581 21.4828 10 25C14.5417 21.4831 18.5 17.7119 19.6667 12.7541C19.8333 12.1185 20 10.6779 20 10.5931V10.1694ZM10 14.4066C7.70833 14.4066 5.83333 12.4999 5.83333 10.1694C5.83333 7.83891 7.70833 5.93215 10 5.93215C12.2917 5.93215 14.1667 7.83891 14.1667 10.1694C14.1667 12.4999 12.2917 14.4066 10 14.4066Z"
        fill="#FC9918" />
    </svg>
    <div class="nologin-loc d-flex" *ngIf="!_as.user_location" style="align-items: center;height:33px">
      <p class="title " style="width: 82px;">Location - </p>
      <a class="location-change-link" (click)="locationService.onLocation()" style="margin-left: 5px;" title="Select your location"> Select your location </a>
    </div>

    <span class="d-flex w-100" *ngIf="_as.user_location?.city"  (click)="locationService.onLocation()" >

      <div class="user-location-icon-address">
        <svg _ngcontent-c1="" class="ng-tns-c1-0" fill="none" height="20" style="margin-right: 8px;" viewBox="0 0 20 25"
          width="20" xmlns="http://www.w3.org/2000/svg">
          <path _ngcontent-c1="" class="ng-tns-c1-0"
            d="M20 10.1694C20 4.53361 15.4167 0 10 0C4.4581 0 0 4.53385 0 10.1694V10.5931C0 10.6355 0.166667 12.1185 0.333333 12.7541C1.5 17.7119 5.4581 21.4828 10 25C14.5417 21.4831 18.5 17.7119 19.6667 12.7541C19.8333 12.1185 20 10.6779 20 10.5931V10.1694ZM10 14.4066C7.70833 14.4066 5.83333 12.4999 5.83333 10.1694C5.83333 7.83891 7.70833 5.93215 10 5.93215C12.2917 5.93215 14.1667 7.83891 14.1667 10.1694C14.1667 12.4999 12.2917 14.4066 10 14.4066Z"
            fill="#FC9918"></path>
        </svg>
        <div class="d-flex align-items-center">
          <p class="title px-1" style="width:70px;">Location -</p>
          <p (click)="locationService.onLocation()">{{_as.user_location.locality}},
            {{_as.user_location.city}}</p>
        </div>

      </div>
    </span>

    <div class="location-pop" [ngClass]="{'active-location-pop':_as.locationPop}" >

      <div class="location-pop-overley-mask" (click)="onShake()">
      </div>
      <div class="location-body" [ngClass]="{'active-location-body':_as.locationPop,'skew-shake-x':isShake}">
        <div class="location-loader-container" *ngIf="locationService.isLoctionLoader">

        </div>
        <div>
          <img ngOptimizedImage class="close-img" *ngIf="isCloseIcon()" src="assets/images/icon/closeicon.png" alt="close" (click)="locationService.closeChangeLocation()"
            loading="lazy">
          <div *ngIf="!_as.user_location?.city ">
            <p class="pb-3 location-heding">Welcome to afterbricks </p>
            <div class="d-flex">
              <img ngOptimizedImage style="height: 35px;margin-right: 4px;"
                src="https://res.cloudinary.com/afterbricks/image/upload/v1667300836/unnamed_pgkys1.png" alt="Provide your location for
                product experience & buying">
              <span style="font-size: 14px;font-family:'SF UI Text Medium';" loading="lazy">Provide your location for
                product experience & buying</span>
            </div>
          </div>
          <p class="pb-2 location-heding" *ngIf="_as.user_location?.city && !_as.isUpdateLocation">Your home location
          </p>
          <p class="pb-2 location-heding" *ngIf="_as.user_location?.city && _as.isUpdateLocation">Select your Location
          </p>
          <div class="location-body-content" *ngIf="_as.user_location?.city && _as.isUpdateLocation">
            <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1667300836/unnamed_pgkys1.png"
              alt="Provide your location for product experience & buyin" loading="lazy">
            <p>Provide your location for product experience & buying</p>
          </div>

          <div class="location-body-btn" *ngIf="!_as.isUpdateLocation && !_as.user_location?.city ">
            <div>
              <div id="usergmap" class="modalmap"></div>
              <input id="pac-input-mob" class="controls pac-inputcss" (focus)="locationService.getLocationsSearchByName()" type="text" placeholder="Enter your Location">
            </div>

            <div class="or-circul py-2" *ngIf="!is_locations_error">
              <p>or</p>
            </div>
            <button class="btn btn-primary" (click)="locationService.getCurrentLocation()" title="Get my location" *ngIf="!is_locations_error">
              <i *ngIf="locationService.isLoctionLoader" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Get my location
            </button>
            <!-- <button class="btn btn-primary" style="pointer-events: none;"
            *ngIf="locationService.isLoctionLoader"><i
              class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></button> -->
          </div>
          <div class="location-body-btn" *ngIf="!_as.isUpdateLocation && !_as.user_location?.city && is_locations_error">
            Enter your location
          </div>
          <div class="location-body-content" *ngIf="_as.user_location?.city && !_as.isUpdateLocation">
            <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1667300836/unnamed_pgkys1.png" alt="locality icon"
              loading="lazy">
            <h3><span *ngIf="_as.user_location.locality">{{_as.user_location.locality}},</span>  {{_as.user_location.city}}</h3>
            <button class="btn btn-success" (click)="locationService.updateLocation()" title="Change">Change</button>
          </div>

          <div class="location-body-btn" *ngIf="_as.user_location?.city && _as.isUpdateLocation">
            <div>
              <div id="usergmap" class="modalmap"></div>

              <input id="pac-input-mob" class="controls pac-inputcss" (focus)="locationService.getLocationsSearchByName()" type="text" placeholder="Enter your Location">
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ab-btn-sec-nav">
    <!-- <a class="ab-btn-sec-nav-a" routerLink="../smart-view" [queryParams]="{q:''}"  *ngIf="!onSmartView()">Smart View</a> -->
    <a class="ab-btn-sec-nav-a" routerLink="../smart-search" [queryParams]="{q:''}"  *ngIf="!onSmartView()">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="36" viewBox="0 0 12 16" fill="none" aria-hidden="true">
        <path d="M6.65723 6.24707C6.76704 5.91764 7.233 5.91765 7.34281 6.24707L7.98828 8.1835C8.276 9.04666 8.95332 9.72399 9.81648 10.0117L11.7529 10.6572C12.0824 10.767 12.0824 11.233 11.7529 11.3428L9.81649 11.9883C8.95332 12.276 8.27599 12.9533 7.98828 13.8165L7.34281 15.7529C7.233 16.0823 6.76704 16.0823 6.65723 15.7529L6.01173 13.8165C5.72401 12.9533 5.04669 12.276 4.18353 11.9883L2.24707 11.3428C1.91764 11.233 1.91764 10.767 2.24707 10.6572L4.18353 10.0117C5.04669 9.72399 5.72401 9.04667 6.01173 8.18352L6.65723 6.24707Z" fill="#9763f6"></path>
        <path d="M2.79434 1.14824C2.86023 0.950586 3.1398 0.950587 3.20569 1.14824L3.59297 2.3101C3.7656 2.828 4.172 3.2344 4.6899 3.40703L5.85177 3.79432C6.04942 3.86021 6.04942 4.13978 5.85177 4.20567L4.6899 4.59296C4.172 4.76559 3.7656 5.17199 3.59297 5.68989L3.20569 6.85176C3.13981 7.04941 2.86023 7.04942 2.79434 6.85176L2.40704 5.68988C2.23441 5.17198 1.82801 4.76559 1.31012 4.59296L0.148241 4.20567C-0.0494137 4.13978 -0.0494138 3.86021 0.148241 3.79432L1.31012 3.40703C1.82802 3.2344 2.23441 2.82801 2.40704 2.31011L2.79434 1.14824Z" fill="#9763f6"></path>
        <path d="M9.8629 0.0988265C9.90682 -0.032943 10.0932 -0.0329419 10.1371 0.098828L10.3953 0.873401C10.5104 1.21867 10.7813 1.4896 11.1266 1.60469L11.9012 1.86288C12.0329 1.9068 12.0329 2.09319 11.9012 2.13711L11.1266 2.39531C10.7813 2.51039 10.5104 2.78133 10.3953 3.12659L10.1371 3.90117C10.0932 4.03294 9.90682 4.03294 9.8629 3.90117L9.6047 3.12659C9.48961 2.78132 9.21868 2.5104 8.87342 2.39531L8.09883 2.13711C7.96706 2.09319 7.96706 1.9068 8.09883 1.86288L8.87342 1.60469C9.21868 1.4896 9.48961 1.21867 9.6047 0.873408L9.8629 0.0988265Z" fill="#9763f6"></path>
      </svg>
      Smart Search 
    </a>
    <div class="project-card-mobile" *ngIf="getProjectStatus()" (click)="_project.onDisplayProjects(true)">
      <div class=" py-0 my-auto project-card" *ngIf="_as.isUserLoggedIn && getShowStatus()">
        <p>
          <span
            *ngIf="(_project.selectedProject && !_project.selectedProject?.is_assigned) || _as.user_info?.is_service_provider"> </span>
          <span
            *ngIf="(_project.selectedProject && _project.selectedProject?.is_assigned) && !_as.user_info?.is_service_provider">Service
            Provider</span>
          <a *ngIf="(_project.selectedProject?.name  && _project.selectedProject?.id && _project.selectedProject?.is_assigned) && !_as.user_info?.is_service_provider"
            (click)="_project.onDisplayProjects(true)" [title]="_project.selectedProject?.name">
            {{_project.selectedProject?.service_provider?.name}}</a>
          <a *ngIf="(_project.selectedProject?.name  && _project.selectedProject?.id && !_project.selectedProject?.is_assigned) || _as.user_info?.is_service_provider"
            (click)="_project.onDisplayProjects(true)" [title]="_project.selectedProject?.name">
            {{_project.selectedProject?.name}}</a>
          <a *ngIf="!_project.selectedProject?.name && _project.selectedProject?.id"
            (click)="_project.onDisplayProjects(true)">Project {{_project.selectedProject?.id}}</a>
          <a *ngIf="!_project.selectedProject?.name && !_project.selectedProject?.id"
            (click)="_project.onDisplayProjects(true)">Select Project</a>
          <!-- <a *ngIf="_project?.project_list?.length" (click)="_project.onDisplayProjects(true)">&nbsp;&nbsp;&nbsp; |
            &nbsp;&nbsp;&nbsp; Total Project : {{_project?.project_list?.length}}</a> -->
  
        </p>
  
      </div>
    </div>
  </div>
  



  <!-----------------------End Mobile location ------------------>
</div>

<!-----------------------Tab-globle-search------------------>
<div class=" globle-search-tab globle-search-mob " id="globle-search-mob" *ngIf="getTabStatus()" >
  <div class="globle-search" [ngClass]="{'golbal-home-search':isShow(),'golbal-home-search-sd':is_top_search_shadow}">
    <div class="search-input-box">
      <input type="text" class="seach-input" [(ngModel)]="_ss.query" (keyup)="newGlobleSearch(_ss.query)" id="dynamic-placeholder"
      [appSuperPlaceholder]="_ss.placeholder_samples" (keyup.enter)="onSearchSmartview()" (focus)="focusSuggetionpup()" >
      <div class="search-icon" (click)="onSearchSmartview()">
        <button type="submit" ><i class="pi pi-arrow-circle-up "></i></button>
       
      </div>
    </div>
    <div class="search-suggestions-popup" *ngIf="isSuggetionPopUp && getSuggetionStatus()">
      <div class="suggestion-box">
        <div class="sug_items" *ngIf="sug_product_types?.length">
          <span class="sug-items-head">{{getProductTypeHeading(sug_product_types)}}</span>
          <ul class="ug-items">
            <li *ngFor="let pt of sug_product_types">
              <a class="suggestion-link" (click)="onTypeLink(pt?.main_category_slug_name,pt.sub_category_id,pt.id)">
                <div class="img-box" *ngIf="pt?.type_icon">
                  <img  [src]="pt?.type_icon" [alt]="pt?.name" ngOptimizedImage>
                </div>
                
                <span>{{pt?.name}}</span>
              </a>
            </li>
          </ul>
         </div>
       <div class="sug_items" *ngIf="sug_sub_categories?.length">
        <span class="sug-items-head">{{getcategoryHeading(sug_sub_categories)}}</span>
        <ul class="ug-items">
          <li *ngFor="let sub of sug_sub_categories">
            <a class="suggestion-link" (click)="onCategoryLink(sub?.main_category_slug_name,sub?.name_slug)" >
              <div class="img-box">
                <img ngOptimizedImage [src]="sub?.category_icon" [alt]="sub?.name">
              </div>
              
              <span>{{sub?.name}}</span>
            </a>
          </li>
        </ul>
       </div>
       <div class="sug_items" *ngIf="sug_brands?.length">
        <span class="sug-items-head">{{getBrandHeding(sug_brands)}}</span>
        <ul class="ug-items">
          <li *ngFor="let brand of sug_brands">
            <a class="suggestion-link" (click)="onBrandLink(brand?.slug_name)" >
              <div class="img-box">
                <img ngOptimizedImage [src]="brand?.icon" [alt]="brand?.brand_name">
              </div>
              <span>{{brand?.brand_name}}</span>
            </a>
          </li>
        </ul>
       </div>
      </div>
      <div class="suggestion-box-products" *ngIf="sug_products?.length">
        <a class="sug-products " (click)="onProductDetail(prod)" *ngFor="let prod of sug_products">
          <div class="sug-p-img">
            <img ngOptimizedImage [src]="prod?.images[0]?.image" [alt]="prod?.name">
          </div>
          <div class="sug-p-text">
            <p>{{prod?.name}}</p>
            <span></span>
            <div class="amout" *ngIf="prod?.effective_price">&#8377; {{prod?.effective_price | number:'1.0-1'}}</div>
          </div>
        </a>
      </div>
      
    </div>
   
    
  </div>
</div>
<!-----------------------End Tab-globle-search ------------------>
<div class="right-slid-prfl" *ngIf="isBrowser">
  <p-sidebar [(visible)]="_as.visibleSideProfile" [dismissible]="true"  [baseZIndex]="20001" position="right" showHeader="false"
    [showCloseIcon]="false" [modal]="true" >
    <div class="close " (click)="_as.visibleSideProfile=false">
      <img ngOptimizedImage src="assets\images\close_dpdfj2.svg" alt="close" loading="lazy">
    </div>
    <div class="row w-100" style="overflow-x:hidden ;">

      <div class="profile-top-trip" *ngIf="_as.isUserLoggedIn">
        <div class="profile-top-trip-box" (click)="profile()">
          <svg _ngcontent-c1="" class="ng-tns-c1-0" fill="#1a374d" height="12" style="margin-right: 16px;"
            viewBox="0 0 18 12" width="18" xmlns="http://www.w3.org/2000/svg">
            <path _ngcontent-c1="" class="ng-tns-c1-0"
              d="M17.3282 5.00011V7.00011L4.49993 7.00011L7.74245 10.2426L6.32824 11.6568L0.671387 5.99999L6.32824 0.34314L7.74245 1.75735L4.4997 5.00011L17.3282 5.00011Z"
              fill="#222"></path>
          </svg>
          <span>
            <div class="side-profile-img">
              <span class="m-block user-first-alp"
                *ngIf="!_as.user_info?.userProfile?.image && loggedInUsername !==undefined">{{loggedInUsername |
                uppercase}}</span>
              <img ngOptimizedImage src="assets\images\Vector_5_rg6wvi.svg"
                *ngIf="!_as.user_info?.userProfile?.image && !loggedInUsername" loading="lazy">
              <img ngOptimizedImage src="{{_as.user_info?.userProfile?.image}}" [alt]="_as.user_info?.userProfile?.username"
                *ngIf="_as.user_info?.userProfile?.image" loading="lazy">
            </div>
          </span>
          <div class="profile-text">
            <span *ngIf="!_as.user_info?.userProfile?.username">My account</span>
            <span *ngIf="_as.user_info?.userProfile?.username">{{_as.user_info?.userProfile?.username}}
              {{_as.user_info?.userProfile?.last_name}}</span>
            <p   *ngIf="_as.user_info?.userProfile?.mobile">{{_as.user_info?.userProfile?.mobile}}</p>
          </div>
        </div>

      </div>
      <div class="profile-card-fixed-right" *ngIf="!_as.isUserLoggedIn">
        <div class="log-sin-btn-container">
          <ul>
            <li>
              <a title="Log In" (click)="_as.onLoginPage()" class="login-btn-2">Log In</a>
            </li>
            <li>
              <a title="Join as Pro" href="{{_as.subscribeUrl}}/home" target="_blank" class="login-btn-2">Join as Pro</a>
            </li>
          </ul>
        </div>

      </div>
      <div class="border-line"></div>
      <div class="right-profile-links firs-right-profile-links ul li a">
        <div>
          <ul>
            <li class="pro-link " *ngIf="_as.isUserLoggedIn">
              <a routerLink="../smart-search" [queryParams]="{q:''}" (click)="_as.visibleSideProfile=false">
                <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1743484920/icons/star_no3sej.png" alt="smart search">
                Smart Search
              </a>
            </li>
            <li class="pro-link project-cl" *ngIf="_as?.isUserLoggedIn">
              <a (click)="onProject()" title="My Project">
              <img  src="https://res.cloudinary.com/afterbricks/image/upload/v1743401926/icons/My_project_iosv9y.png" alt="my project"
                ngOptimizedImage style="height: 20px; width: 20px;" width="20" height="20">
                <!-- <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1725715379/icons/image_4_jkswtt.png" alt="my project"> -->
                My Project
              </a>
            </li>
            <li class="pro-link">
              <a (click)="onSaveIdea()" title="Saved Ideas">
                <img src="https://res.cloudinary.com/afterbricks/image/upload/v1743403099/icons/Saved_idea_e9t33f.png" alt="Saved Ideas"
                  ngOptimizedImage style="height: 20px; width: 20px;" width="20" height="20">
                Saved Ideas
                <p-badge *ngIf="_as.isUserLoggedIn && _project.cart_data?.save_indea_product_count"
                  [value]="_project.cart_data?.save_indea_product_count" severity="info" styleClass="mr-2"></p-badge>
              </a>
            </li>
            <li class="pro-link" *ngIf="(_project.cart_data?.cart_product_count || _project.cart_data?.compare_offer_count) && (!_project.selectedProject?.is_assigned || _as.user_info.is_service_provider)">
              <a (click)="onCart()" title="cart">
                <img ngOptimizedImage style="height: 20px; width: 20px;" width="20" height="20"
                  src="https://res.cloudinary.com/afterbricks/image/upload/v1743401926/icons/My_list_biljtl.png" alt="cart"
                  loading="lazy">
                Cart
                <p-badge *ngIf="_as.isUserLoggedIn && _project.cart_data?.cart_product_count"
                  [value]="_project.cart_data?.cart_product_count" severity="info"></p-badge>
              </a>
            </li>
            <li class="pro-link" >
              <a (click)="onSampleOrders()" title="My Sample orders">
                <img ngOptimizedImage style="height: 20px; width: 20px;" width="20" height="20"
                  src="https://res.cloudinary.com/afterbricks/image/upload/v1743404312/icons/Sample_2_lqz6jl.png" alt="My List"
                  loading="lazy">
                My Sample order
               
              </a>
            </li>
            <li class="pro-link" *ngIf="!_project.selectedProject?.is_assigned || _as.user_info.is_service_provider">
              <a (click)="goToOrderPage()" title="Order Status">
                <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1743404378/icons/Order_quekyy.png" alt="order status" loading="lazy">
                Order Status
              </a>
            </li>
            <!-- <li class="pro-link">
              <a [routerLink]="['/store-visits']" (click)="instantshow()" title="Store Visits">
                <img ngOptimizedImage style="height: 20px; width: 20px;" width="20" height="20"
                src="https://res.cloudinary.com/afterbricks/image/upload/v1743404378/icons/Store_tk9fvl.png" alt="Store visits" loading="lazy">
                Store Visits
                <p-badge *ngIf="_as.isUserLoggedIn && _project.selectedProject?.project_steps?.store_visits"
                  [value]="_project.selectedProject?.project_steps?.store_visits" severity="info"
                  styleClass="mr-2"></p-badge>
              </a>
            </li>
            <li class="pro-link"
              *ngIf="_project.selectedProject?.project_steps?.myComapreOffer"
              (click)="openBrandPopup()">
              <a title="Compare deal">
                <img ngOptimizedImage style="height: 20px; width: 20px;" width="20" height="20"
                src="https://res.cloudinary.com/afterbricks/image/upload/v1743404545/icons/compare_bvxkuu.png" alt="Compare deal" loading="lazy">
                Compare deal
                <p-badge *ngIf="_as.isUserLoggedIn && _project.selectedProject?.project_steps?.myComapreOffer"
                  [value]="_project.selectedProject?.project_steps?.myComapreOffer" severity="info"
                  styleClass="mr-2"></p-badge>
              </a>
            </li> -->
          </ul>
        </div>

      </div>
      <div class="border-line"></div>
      <div class="right-profile-links">
        <div>
          <ul>
            <li class="pro-link">
              <a (click)="onProduct()" (click)="instantshow()" title="Products">
                <img ngOptimizedImage style="height: 20px; width: 20px;" width="20" height="20"
                src="https://res.cloudinary.com/afterbricks/image/upload/v1743404487/icons/Product_txirhd.png" alt="Product" loading="lazy">
                Products
              </a>
            </li>
            <li class="pro-link">
              <a [routerLink]="['/brand']" (click)="instantshow()" title="Brands">
                <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1743404447/icons/Brands_2_c9tcss.png" alt="Brand" loading="lazy">
                Brands
              </a>
            </li>
            <li class="pro-link">
              <a [routerLink]="['/service-provider']" (click)="instantshow()" title="Professional">
                <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1743401926/icons/Professional_kwzdsx.png" alt="Professional" loading="lazy">
                Professional
              </a>
            </li>
          </ul>
        </div>

      </div>
      <div class="border-line"></div>
      <div class="right-profile-links" *ngIf="_as.isUserLoggedIn">
        <div>
          <ul>
            <li class="pro-link">
              <a (click)="goToProfile()" title="Edit profile">
                <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1743485520/icons/edit_eayxey.png" alt="Edit profile" loading="lazy">  
                Edit-Profile
              </a>
            </li>
            <li class="pro-link">
              <a (click)="logoutUser()" title="Log Out">
                <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1743485520/icons/log-out_gr38g6.png" alt="Log Out" loading="lazy">
                Log Out
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </p-sidebar>
</div>


<!------------------------- Notifications--------------------------------->
<div class="notificationdiv" *ngIf="shownotification && isBrowser">
  <div class="row">
    <div class="col-12 NotofyHeadING p-0 d-flex justify-content-between">
      <h4>Your Notification</h4>
      <div class="close-notification-modal" (click)="shownotification=false">
        <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1672648092/unnamed_pnyzfp.png" alt="close"
          loading="lazy">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="REcentdata col-12 px-0">
      <p>RECENT</p>
    </div>
    <div class="col-12 px-0">
      <div class="w-100" *ngFor="let info of notification">
        <div class="showtextDATA" [ngClass]="{'REaded':info.is_read}" *ngIf="info.time.h || info.time.m || info.time.s"
          (click)="redirect(info.link,info.id,info.notification)">
          <div class="noti-pro-img" *ngIf="!info.profile_pic">
            {{info.notification.showroom_name[0]}}
          </div>
          <div class="SHOWIcons" [ngClass]="{'REaded':info.is_read}" *ngIf="info.profile_pic">
            <img ngOptimizedImage width="50" height="50" [src]="info.profile_pic" [alt]="info.notification.showroom_name" loading="lazy" />
          </div>
          <div class="SHOwMEssaGe" [ngClass]="{'REaded':info.is_read}">
            <p *ngIf="info.notification.noti_type ==='cartage_replace'">
              <span class="MesiBold">{{info.notification.showroom_name}}
                ({{info.notification.brand_name}})</span> has responded with his price offer & cartage
            </p>
            <p *ngIf="info.notification.noti_type ==='dispatch_partial_order'">

              <span class="MesiBold">{{info.notification.showroom_name}}
                ({{info.notification.brand_name}})</span> has dispatched partial order
            </p>
            <p *ngIf="info.notification.noti_type ==='dispatch_complete_order'">
              <span class="MesiBold">{{info.notification.showroom_name}}
                ({{info.notification.brand_name}})</span> has dispatched final order
            </p>
            <p *ngIf="info.notification.noti_type ==='dispatch_full_order'">
              <span class="MesiBold">{{info.notification.showroom_name}}
                ({{info.notification.brand_name}})</span> has dispatched complete order
            </p>
            <p> <span *ngIf="!info.time.h && !info.time.m">{{info.time.s}}s</span>
              <span *ngIf="!info.time.h && !info.time.s">{{info.time.m }}m</span>
              <span *ngIf="!info.time.m && !info.time.s">{{info.time.h}}h</span>
            </p>
          </div>
          <div class="text-center" [ngClass]="{'visible-dot':info.is_read}">
            <span class="dot"></span>
          </div>
        </div>
      </div>
      <div class="w-100 d-grid justify-content-center text-center" *ngIf="!notification?.length">
        <i class="fas fa-bell-slash"></i>
        <div class="NOnewNOtific px-0">
          <p>No new notification</p>
        </div>
      </div>
    </div>
    <div class="col-11 h-vline"></div>
    <div class="REcentdata col-12 px-0">
      <p>EARLIER</p>
    </div>
    <div class="col-12 mob-pad-16" *ngIf="notification?.length">
      <div class="w-100" *ngFor="let info of notification">
        <div class="showtextDATA" [ngClass]="{'REaded':info.is_read}" *ngIf="info.time.days"
          (click)="redirect(info.link,info.id,info.notification)">
          <div class="noti-pro-img" *ngIf="!info.profile_pic">
            {{info.notification.showroom_name}}
          </div>
          <div class="SHOWIcons" *ngIf="info.profile_pic">
            <img ngOptimizedImage [src]="info.profile_pic" [alt]="info.notification.showroom_name" loading="lazy" />
          </div>
          <div class="SHOwMEssaGe" [ngClass]="{'REaded':info.is_read}">
            <p *ngIf="info.notification.noti_type ==='cartage_replace'">
              <span class="MesiBold">{{info.notification.showroom_name}}
                ({{info.notification.brand_name}})</span> has responded with his price offer & cartage
            </p>
            <p *ngIf="info.notification.noti_type ==='dispatch_partial_order'">

              <span class="MesiBold">{{info.notification.showroom_name}}
                ({{info.notification.brand_name}})</span> has dispatched partial order
            </p>
            <p *ngIf="info.notification.noti_type ==='dispatch_complete_order'">
              <span class="MesiBold">{{info.notification.showroom_name}}
                ({{info.notification.brand_name}})</span> has dispatched final order
            </p>
            <p *ngIf="info.notification.noti_type ==='dispatch_full_order'">
              <span class="MesiBold">{{info.notification.showroom_name}}
                ({{info.notification.brand_name}})</span> has dispatched complete order
            </p>
            <p>
              <span class="hours"
                *ngIf="info.time.days && !info.time.m && !info.time.h && !info.time.s">{{info.time.days}}
                d</span>
            </p>
          </div>
          <div class="text-center invisible-h" [ngClass]="{'visible':!info.is_read}">
            <span class="dot"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 px-0" *ngIf="!notification?.length">
      <div class="NOnewNOtific">
        <p>No new notification</p>
      </div>
    </div>
    <div class="see-all button col-12 px-0">
      <button (click)="getMoreNotifications()" title="See All">See All</button>
    </div>
  </div>
</div>
<!----------------------------------Notifications END-------------------------------------->

<div class="megamenu-slider-left" *ngIf="isBrowser">
  <p-sidebar [(visible)]="_as.displayNavSlider" [blockScroll]="true" [baseZIndex]="20001" position="left"
    [showCloseIcon]="false" (onHide)="clearData()">
    <div class="main-category-menu-mega">

      <div class="close-slider" (click)="_as.displayNavSlider=false">
        <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1672648092/unnamed_pnyzfp.png" alt="close"
          loading="lazy">
      </div>
      <div class="top-heading" style="margin-bottom: 24px;">
        <div class="row profile-card-fixed">

          <div class="profile-pic-container w-100 " *ngIf="_as.isUserLoggedIn" style="cursor: pointer">
            <div class="profile-name-container w-100 d-flex" (click)="profile()">
              <a [title]="_as.user_info?.userProfile?.username">
                <div class="pro-img">
                  <span class="m-block user-first-alp"
                    *ngIf="!_as.user_info?.userProfile?.image && loggedInUsername !==undefined">{{loggedInUsername |
                    uppercase}}</span>
                  <i class="fa-solid fa-user"
                    *ngIf="_as.isUserLoggedIn && !_as.user_info?.userProfile?.image && !loggedInUsername"></i>
                  <img ngOptimizedImage src="{{_as.user_info?.userProfile?.image}}" [alt]="_as.user_info?.userProfile?.username"
                    *ngIf="_as.user_info?.userProfile?.image" loading="lazy">
                </div>
              </a>

              <div class="sidebarData">
                <a style="cursor: pointer;" [title]="_as.user_info?.userProfile?.username"
                  *ngIf="_as.user_info?.userProfile?.username">{{_as.user_info?.userProfile?.username}}
                  {{_as.user_info?.userProfile?.last_name}}</a>
                <a class="sn-lo-pa active pro-name-a" *ngIf="!_as.user_info?.userProfile?.username"
                  (click)="_as.visibleSideProfile=true" title="My Account">
                  My Account
                </a>
                <p class="color-white" *ngIf="_as.user_info?.userProfile?.mobile">
                  +91 {{_as.user_info?.userProfile?.mobile}}</p>
              </div>
            </div>
          </div>
          <div *ngIf="!_as.isUserLoggedIn">
            <div class="log-sin-btn-container">
              <ul class="d-flex">
                <li>
                  <a class="m-login-btn" (click)="_as.onLoginPage()" title="Log In">Log In</a>
                </li>

              </ul>
            </div>
          </div>
        </div>

      </div>
      <div class="side-bar-menu-body">
        <div>
          <ul class="main-category-list">
            <li class="ripple" *ngFor="let mc of _ds.departments_list;let mci=index">

              <a class="main-category-item" (click)="onMainCategory(mc.id,mci)" [title]="mc?.name">
                <div class="d-flex align-items-center">
                  <div class="related-icon">
                    <img ngOptimizedImage width="45" height="45" src={{mc.icon}} [alt]="mc?.name" loading="lazy">
                  </div>
                  {{mc?.name}}<span class="main-category-item-span">{{mc?.product_count}}</span>
                </div>
                <svg width="14" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                  *ngIf="mci!=activemcIndex">
                  <path
                    d="M8 0C7.44772 0 7 0.447715 7 1V7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H7V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H9V1C9 0.447715 8.55229 0 8 0Z"
                    fill="#222" />
                </svg>

                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                  *ngIf="mci==activemcIndex">
                  <path
                    d="M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
                    fill="#222" />
                </svg>
              </a>

              <div class="department-detail" *ngIf="mci==activemcIndex">
                <ul class="sub-cat-manu">
                  <li *ngFor="let sc of mc?.sub_category_list;let sci=index">
                    <div *ngIf="!sc.product_types.length">
                      <a class="sub-category-item" *ngIf="!sc.is_coming_soon" routerLink="./product/{{mc.slug_name}}"
                        [queryParams]="{subCat:sc.id}" (click)="onCategoryTypeLink(mc?.slug_name,sc?.id,undefined)" [title]="sc?.name">
                        <div class="d-flex " style="align-items: center; ">
                          <div class="circel-bullet"></div> {{sc?.name}}
                        </div>
                      </a>
                    </div>
                    <div (click)="onSubCategory(sc.id,sci)" *ngIf="sc.product_types.length">
                      <a class="sub-category-item" [title]="sc?.name">
                        <div class="d-flex " style="align-items: center;">
                          <div class="circel-bullet"></div> {{sc?.name}}
                        </div>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                          *ngIf="sci!=activescIndex">
                          <path
                            d="M8 0C7.44772 0 7 0.447715 7 1V7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H7V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H9V1C9 0.447715 8.55229 0 8 0Z"
                            fill="#222" />
                        </svg>

                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                          *ngIf="sci==activescIndex">
                          <path
                            d="M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
                            fill="#222" />
                        </svg>
                      </a>

                    </div>
                    <ul class="sub-category-type-ul" *ngIf="activesctId==sc.id">
                      <li *ngFor="let ct of sc.product_types;">
                        <a class="sub-category-type-item" *ngIf="!ct.is_coming_soon"
                          routerLink="./product/{{mc.slug_name}}" [queryParams]="{ subCat:sc.id, category:ct.id}"
                          (click)="onCategoryTypeLink(mc?.slug_name,sc?.id,undefined,ct?.id)" [title]="ct.name">{{ct.name}}</a>
                      </li>
                    </ul>

                  </li>
                </ul>
              
              </div>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </p-sidebar>
</div>

<div class="basic-info-popup"
  *ngIf="!isOnMobilePlatform && (_project.project_list?.length || _project.assigned_projects?.length) && isBrowser">
  <p-dialog [(visible)]="_project.displayProject" [modal]="true" [baseZIndex]="10000" [style]="{ minWidth: '200px'}"
    [showHeader]="false" [blockScroll]="true">
    <div class="ab-modal">
      <div class="close-popup" (click)="_project.closeDisplayProjects()">
        <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt=""
          loading="lazy">
      </div>
      <div class="ab-modal-heading">
        <h3>My Project </h3>
        <p>Select one from below</p>
      </div>

      <div class="ab-modal-body px-0 project-body">
        <ul class="ab-p-project-list" *ngIf="!_as.user_info?.is_assigned">
          <li *ngFor="let proj of _project.project_list.slice(0,8)">
            <div class="ab-p-project-card"
              [ngClass]="{'active-ab-p-project-card':_project.selectedProject?.id==proj?.id}"
              (click)="_project.onSelectProject(proj)">
              <span>Id : {{proj.id}}</span>
              <h3 *ngIf="!proj?.name">Project name</h3>
              <h3 *ngIf="proj?.name">{{proj?.name}}</h3>
              <div class="BHK-ICON flex"><img ngOptimizedImage
                  [src]="proj?.house_type?.icon" [alt]="proj?.house_type?.name">
                <span>{{proj?.house_type?.name}}</span>
              </div>
              <p>{{proj?.location}}</p>
              <p>{{proj?.city}}</p>
             
              <div class="ab-project-card-link">
                <a class="ab-link-btn" style="margin-left: 9px;"
                  (click)="goToProductPage(proj);$event.stopPropagation();" title="Products">Products</a>
                <a class="ab-link-btn" style="margin-left: 4px;" title="Collection" *ngIf="proj?.project_steps?.savedIdeas"
                  (click)="goToCollection(proj);$event.stopPropagation();">Collection</a>
              </div>
            </div>
          </li>
          <li class="new-project-create-box">
            <a class="ab-project-card" titel="Create new project" (click)="_project.ondisplayProjectPopup()">
              <div class="ab-add-project-box">
                <i class="fa-solid fa-plus"></i>
                <span>Create new project</span>
              </div>
            </a>
          </li>
        </ul>
        <ul class="ab-p-project-list" *ngIf="_as.user_info?.is_assigned">
          <li *ngFor="let proj of  _project.assigned_projects.slice(0,8)">
            <div class="ab-p-project-card"
              [ngClass]="{'active-ab-p-project-card':_project.selectedProject?.id==proj?.id}"
              (click)="_project.onSelectProject(proj)">
              <span>Id : {{proj.id}}</span>
              <h3 *ngIf="proj?.name">{{proj?.name}}</h3>
              <h3 *ngIf="!proj?.name">Project name</h3>
              <div class="BHK-ICON flex"><img ngOptimizedImage
                  [src]="proj?.house_type?.icon" [title]="proj?.house_type?.name">
                <span>{{proj?.house_type?.name}}</span>
              </div>
              <p style="font-size: 12px;" [ngClass]="{'assigned-ab-project':_as.user_info?.is_assigned}">Project assigned by {{proj?.service_provider?.name}}, your service provider.</p>
              
              <p>{{proj?.location}}</p>
              <p>{{proj?.city}}</p>
              <div class="ab-project-card-link">
                <a class="ab-link-btn" (click)="goToProductPage(proj);$event.stopPropagation();" title="Products">Products</a>
                <a class="ab-link-btn" (click)="goToCollection(proj);$event.stopPropagation();"
                  style="margin-left: 6px;" *ngIf="proj?.is_assigned && proj?.project_steps?.savedIdeas" title="Collection">Collection</a>
              </div>
            </div>
          </li>
          <li *ngFor="let proj of _project.project_list.slice(0,8)">
            <div class="ab-p-project-card"
              [ngClass]="{'active-ab-p-project-card':_project.selectedProject?.id==proj?.id}"
              (click)="_project.onSelectProject(proj)">
              <span>Id : {{proj.id}}</span>
              <h3 *ngIf="proj?.name">{{proj?.name}}</h3>
              <h3 *ngIf="!proj?.name">Project name</h3>
              <div class="BHK-ICON flex"><img ngOptimizedImage
                  [src]="proj?.house_type?.icon" [alt]="proj?.house_type?.name">
                <span>{{proj?.house_type?.name}}</span>
              </div>
              <p>{{proj?.location}}</p>
              <p>{{proj?.city}}</p>
            </div>
          </li>
          <li class="new-project-create-box">
            <a class="ab-project-card" title="Create new project" (click)="_project.ondisplayProjectPopup()">
              <div class="ab-add-project-box">
                <i class="fa-solid fa-plus"></i>
                <span>Create new project</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="see-more text-end" *ngIf="_project?.project_list?.length > 8">
      <a routerLink="/ab-project" title="See more projects" (click)="_project.displayProject=false">See more projects</a>
    </div>
  </p-dialog>
</div>
<div class="basic-info-popup"
  *ngIf="isOnMobilePlatform && (_project.project_list?.length || _project.assigned_projects?.length) && isBrowser">
  <p-sidebar [(visible)]="_project.displayProject" [baseZIndex]="10000" position="bottom" [showCloseIcon]="false">
    <div class="ab-modal">
      <div class="close-popup" (click)="_project.closeDisplayProjects()">
        <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt=""
          loading="lazy">
      </div>
      <div class="ab-modal-heading">
        <h3>My Project <span>select one from below</span></h3>
      </div>

      <div class="ab-modal-body px-0 project-body">
        <ul class="ab-p-project-list" *ngIf="!_as.user_info?.is_assigned">
          <li *ngFor="let proj of _project.project_list.slice(0,8)">
            <div class="ab-p-project-card"
              [ngClass]="{'active-ab-p-project-card':_project.selectedProject?.id==proj?.id}"
              (click)="_project.onSelectProject(proj)">
              <span>Id : {{proj.id}}</span>
              <h3 *ngIf="proj?.name">{{proj?.name}}</h3>
              <div class="BHK-ICON flex"><img ngOptimizedImage
                  [src]="proj?.house_type?.icon" [title]="proj?.house_type?.name">
                <span>{{proj?.house_type?.name}}</span>
              </div>
              <h3 *ngIf="!proj?.name">Project name</h3>
              <p>{{proj?.location}}</p>
              <p>{{proj?.city}}</p>
              <div class="ab-project-card-link">
                <a class="ab-link-btn" (click)="goToProductPage(proj);$event.stopPropagation();" title="Products">Products</a>
                <a class="ab-link-btn" style="margin-left: 2px;" *ngIf="proj?.project_steps?.savedIdeas"
                  (click)="goToCollection(proj);$event.stopPropagation();" title="Collection">Collection</a>
              </div>
            </div>
          </li>
          <li class="new-project-create-box">
            <a class="ab-project-card" title="Create new project" (click)="_project.ondisplayProjectPopup()">
              <div class="ab-add-project-box">
                <i class="fa-solid fa-plus"></i>
                <span>Create new project</span>
              </div>

            </a>
          </li>
        </ul>
        <ul class="ab-p-project-list" *ngIf="_as.user_info?.is_assigned">
          <li *ngFor="let proj of  _project.assigned_projects.slice(0,8)">
            <div class="ab-p-project-card"
              [ngClass]="{'active-ab-p-project-card':_project.selectedProject?.id==proj?.id}"
              (click)="_project.onSelectProject(proj)">
              <span>Id : {{proj.id}}</span>
              <h3 *ngIf="proj?.name">{{proj?.name}}</h3>
              <h3 *ngIf="!proj?.name">Project name wwww</h3>
              <div class="BHK-ICON flex"><img ngOptimizedImage
                  [src]="proj?.house_type?.icon" [alt]="proj?.house_type?.name">
                <span>{{proj?.house_type?.name}}</span>
              </div>
              <p style="font-size: 13px;line-height: 121%;"
                [ngClass]="{'assigned-ab-project':_as.user_info?.is_assigned}">This project was assigned by
                {{proj?.service_provider?.name}} your
                service provider</p>
               
              <p>{{proj?.location}}</p>
              <p>{{proj?.city}}</p>
              <div class="ab-project-card-link">
                <a class="ab-link-btn" (click)="goToProductPage(proj);$event.stopPropagation();" title="Products">Products</a>
                <a class="ab-link-btn" style="margin-left: 23px;"
                  *ngIf="proj?.is_assigned && proj?.project_steps?.savedIdeas" title="Collection"
                  (click)="goToCollection(proj);$event.stopPropagation();">Collection</a>
              </div>
            </div>
          </li>
          <li *ngFor="let proj of _project.project_list.slice(0,8)">
            <div class="ab-p-project-card"
              [ngClass]="{'active-ab-p-project-card':_project.selectedProject?.id==proj?.id}"
              (click)="_project.onSelectProject(proj)">
              <span>Id : {{proj.id}}</span>
              <h3 *ngIf="proj?.name">{{proj?.name}}</h3>
              <h3 *ngIf="!proj?.name">Project name</h3>
              <div class="BHK-ICON flex"><img ngOptimizedImage
                  [src]="proj?.house_type?.icon" [title]="proj?.house_type?.name">
                <span>{{proj?.house_type?.name}}</span>
              </div>
              <p>{{proj?.location}}</p>
              <p>{{proj?.city}}</p>
            </div>
          </li>
          <li class="new-project-create-box">
            <a title="Create new project" class="ab-project-card" (click)="_project.ondisplayProjectPopup()">
              <div class="ab-add-project-box">
                <i class="fa-solid fa-plus"></i>
                <span>Create new project</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="see-more text-end" *ngIf="_project?.project_list?.length > 9">
      <a routerLink="/ab-project" title="See more projects" (click)="_project.displayProject=false">See more projects</a>
    </div>
  </p-sidebar>
</div>

<div *ngIf="isBrowser">
  <app-infopopup ></app-infopopup>
<!-- Assign project popup for service provider only -->
<div class="basic-info-popup" *ngIf="!isOnMobilePlatform ">
 
  <p-dialog [(visible)]="_project.displaypopupAssign" [modal]="true" [showHeader]="false"
    [style]="{width: '600px', height:'400px', minWidth: '200px'}" [minY]="70" [maximizable]="true" [baseZIndex]="10000">
    <div class="pros-popover-close" (click)="_project.displaypopupAssign=false" title="Close">
      <i class="fa-solid fa-xmark"></i>
    </div>
    <div class="ab-modal">
      <div class="ab-modal-heading">
      
        <h3>Share your amazing product collection!</h3>
        <p>Engage your client in product selection process & win his trust</p>
      </div>
      <div class="ab-modal-body">
        <div>
          <div class="form-group">

            <!-- <label class="required-field" for="mobile">Mobile*</label> -->
            <input placeholder="Enter your name" maxlength="10" class="form-control rsp-input w-100 text-left"
              type="tel" placeholder="Mobile" size="30" [(ngModel)]="_project.mobile" onfocus="this.placeholder = ''"
              onblur="this.placeholder='Mobile'" numbersOnly required pInputText autocomplete="none|false|no"
              (keydown.space)="$event.preventDefault();" required>
            <span *ngIf="_project.is_mobile_error" class="err-text">Mobile required</span>
          </div>
          <div class="form-group">
            <!-- <label class="required-field" for="customer_name">Client name*</label> -->
            <input type="text" class="form-control rsp-input w-100 text-left" id="customer_name"
              [(ngModel)]="_project.customer_name" name="customer_name" placeholder="Enter your client name" required
              pInputText>

            <span *ngIf="_project.is_customer_name_error" class="err-text">Name required</span>
          </div>

        </div>
        <div class="assign-error-strip" *ngIf="_project.isProjectAssignError">
          {{_project.error_message}}
        </div>
      </div>

      <div class="ab-modal-footer">
        
        <div class="shre-btn" *ngIf="!_project.inLineLoader" title="Share" (click)="_project.onAssignSubmit()">
          <i class=" fa-regular fa-share-from-square" style="margin-right: 8px;"></i> Share
        </div>
        <button *ngIf="_project.inLineLoader" title="Assign">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="margin-right: 8px;"></i>
          Assign <i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>
  </p-dialog>
</div>
<div class="basic-info-popup" *ngIf="isOnMobilePlatform">
  <p-sidebar [(visible)]="_project.displaypopupAssign" [modal]="true" position="bottom"
    [style]="{width: '100%', minWidth: '200px'}" [baseZIndex]="10000">
    <div class="ab-modal">
      <div class="ab-modal-heading">
        <h3>Share your amazing product collection!</h3>
        <p>Engage your client in product selection process & win his trust</p>
      </div>
      <div class="ab-modal-body">
        <div>
          <div class="form-group">
            <!-- (keyup)="checkmobile()" -->
            <!-- <label class="required-field" for="mobile">Mobile*</label> -->
            <input placeholder="Enter your name" maxlength="10" class="form-control rsp-input w-100 text-left"
              type="tel" placeholder="Mobile" size="30" [(ngModel)]="_project.mobile" onfocus="this.placeholder = ''"
              onblur="this.placeholder='Mobile'" numbersOnly required pInputText autocomplete="none|false|no"
              (keydown.space)="$event.preventDefault();" required>
            <span *ngIf="_project.is_mobile_error" class="err-text">Mobile required</span>
          </div>
          <div class="form-group">
            <!-- <label class="required-field" for="customer_name">Client name*</label> -->
            <input type="text" class="form-control rsp-input w-100 text-left" id="customer_name"
              [(ngModel)]="_project.customer_name" name="customer_name" placeholder="Enter your client name" required
              pInputText>
            <!-- (keyup)="customer_name_field()" -->
            <span *ngIf="_project.is_customer_name_error" class="err-text">Name required</span>
          </div>

        </div>
        <div class="assign-error-strip" *ngIf="_project.isProjectAssignError">
          {{_project.error_message}}
        </div>
      </div>

      <div class="ab-modal-footer">
        <button (click)="_project.displaypopupAssign=false" title="Close"> Close</button>
        <button title="Share" *ngIf="!_project.inLineLoader" class="d-flex" (click)="_project.assignProject()">
          <i class="fa-regular fa-share-from-square" style="margin-right: 8px;"></i> Share
        </button>
        <button title="Assign" *ngIf="_project.inLineLoader" class="d-flex"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"
            style="margin-right: 8px;"></i>
          Assign <i class="fa-solid fa-angle-right"></i></button>

      </div>
    </div>
  </p-sidebar>
</div>
<!-- End assign project popup for service provider only -->

<!------Department popup start---------->

<div class="basic-info-popup wt-block" *ngIf="!isOnMobilePlatform">
  <p-dialog [(visible)]="_hs.isdisplybrandpopup" [modal]="true" [showHeader]="false" [baseZIndex]="10000"
    [transitionOptions]="_pop.dialogTransitionTime" [dismissableMask]="_pop.closeOutside" transitionOptions="350ms cubic-bezier(0, 0, 0.2, 1)">
    <div>
      <div class="close-popup" (click)="_hs.isdisplybrandpopup=false">
        <img ngOptimizedImage alt="close" src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg">
      </div>
      <div class="ab-modal-heading">
        <h3>Select by Department</h3>
        <!-- <p>Click below and continue </p> -->
      </div>
      <div>
        <ul class="ab-modal-body-ul">
          <li class="ab-modal-body-card" (click)="goToDeptPage(mc)"
            *ngFor="let mc of this._ds.departments_list;let mci=index">
            <div class="ab-modal-body-img">
              <img ngOptimizedImage width="64" height="69" *ngIf="mc?.icon" [src]="mc?.icon" [alt]="mc?.name" loading="lazy">
            </div>

            <div class="ab-modal-dept-name">
              <p>{{mc?.name}}</p>
            </div>

          </li>
        </ul>
      </div>
    </div>
  </p-dialog>
</div>


<div class="basic-info-popup m-block" *ngIf="isOnMobilePlatform">
  <p-sidebar [(visible)]="_hs.isdisplybrandpopup" position="bottom" [modal]="true" [baseZIndex]="10000">
    <div class="close-popup" (click)="_hs.isdisplybrandpopup=false">
      <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt=""
        loading="lazy">
    </div>
    <div class="ab-modal-heading">
      <h3>Select by Department</h3>
      <!-- <p>Click below and continue</p> -->
    </div>
    <div>
      <ul class="ab-modal-body-ul">
        <li *ngFor="let mc of this._ds.departments_list;let mci=index" (click)="goToDeptPage(mc)">
          <a [title]="mc?.name">
            <div class="ab-modal-body-card">
              <div class="ab-modal-body-img">
                <img ngOptimizedImage width="64" height="69" [src]="mc?.icon" [alt]="mc?.name" loading="lazy">
              </div>

              <div class="ab-modal-dept-name">
                <p>{{mc?.name}}</p>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </p-sidebar>
</div>
<!--Departments-Popup End -->

<div class="success-popup" >
  <p-dialog [(visible)]="_trial.isTrialExpire" [showHeader]="false" [modal]="true" [closable]="false"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="success-msg-container">
      <div class="success-img">
        <img ngOptimizedImage src="assets/images/exclamation.png" alt="proceed">
      </div>
      <h4>Heads up!</h4>
      <p>
        Your 3 days free trial is expired, Now you need to do payment to use afterbricks premium services.
      </p>
    </div>
    <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" (click)="onProceedPayment()" label="Proceed" styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>
</div>

<!-----------------API response time delay popup------------------------>
<div class="success-popup" >
  <p-dialog [(visible)]="_pop.showResponseDelay" [showHeader]="false" [modal]="true" [closable]="false"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="success-msg-container">
      <div class="success-img">
        <img ngOptimizedImage src="assets/images/exclamation.png" alt="proceed">
      </div>
      <h4>Heads up!</h4>
      <p>
        Something went wrong, Please try again later.
      </p>
    </div>
    <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" (click)="_pop.showResponseDelay=false" label="Try Again"
        styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>
</div>

<!-----------------END API response time delay popup------------------------>

<!-----------------API response time delay popup------------------------>
<div class="success-popup" >
  <p-dialog [(visible)]="_pop.showResponseDelay" [showHeader]="false" [modal]="true" [closable]="false"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="success-msg-container">
      <div class="success-img">
        <img ngOptimizedImage src="assets/images/exclamation.png" alt="proceed">
      </div>
      <h4>Heads up!</h4>
      <p>
        Something went wrong, Please try again later.
      </p>
    </div>
    <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" (click)="_pop.showResponseDelay=false" label="ok"
        styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>
</div>

<!-----------------END API response time delay popup------------------>
<!-----------------Rewards Rates & Terms sidebar---------------------->

<div class="basic-info-popup" *ngIf="!_as.isOnMobilePlatform">
  <p-dialog [(visible)]="_cs.isDesplayBrandStore" [showHeader]="false" [modal]="true" [closable]="false" [baseZIndex]="10000"
      [draggable]="false" [resizable]="false">
      <div class="ab-modal">
          <div class="ab-modal-heading">
              <h3>Stores</h3>
              <p>Please choose the store where you purchased the product from.</p>
          </div>

          <div class="ab-modal-body">
              <div class="form-container">
                  <ul class="cb-ul">
                      <li *ngFor="let dealer of _cs.dealers_list;let di=index;let last=last">
                          <a class="dc" (click)="_cs.onSelectDealer(dealer)">
                              <div class="dc-1">
                                  <img ngOptimizedImage [src]="dealer?.showroom_image_list[0]?.showroom_image_url"
                                      *ngIf="dealer?.showroom_image_list[0]?.showroom_image_url"
                                      [alt]="dealer?.showroom_name">
                              </div>
                              <div class="dc-2">
                                  <h4>{{dealer?.showroom_name}}</h4>
                                  <p><span>{{dealer?.address2}},</span> {{dealer?.city}}</p>
                              </div>
                          </a>
                      </li>
                  </ul>
              </div>
          </div>

          <div class="ab-modal-footer">
              <div>
                  <button (click)="_cs.onCloseBrandStorePopup()" style="font-size: 14px;
      border: none;
      background-color: transparent;
      font-family: 'SF UI Text Regular';
      color: #858181 !important;
      margin-right: 16px;background-color: #fff;">Close</button>
              </div>
              <div>
              </div>
          </div>
      </div>
  </p-dialog>
</div>

<div class="basic-info-popup" *ngIf="_as.isOnMobilePlatform">
  <p-sidebar [(visible)]="_cs.isDesplayBrandStore"  [modal]="true" [blockScroll]="true" position="bottom" [baseZIndex]="10000"
      [draggable]="false" >
      <div class="ab-modal">
          <div class="ab-modal-heading">
              <h3>Stores</h3>
              <p>Please choose the store where you purchased the product from.</p>
          </div>

          <div class="ab-modal-body " style="padding-bottom: 60px;">
              <div class="form-container">
                  <ul class="cb-ul">
                      <li *ngFor="let dealer of _cs.dealers_list;let di=index;let last=last">
                          <a class="dc" (click)="_cs.onSelectDealer(dealer)">
                              <div class="dc-1">
                                  <img ngOptimizedImage [src]="dealer?.showroom_image_list[0]?.showroom_image_url"
                                      *ngIf="dealer?.showroom_image_list[0]?.showroom_image_url"
                                      [alt]="dealer?.showroom_name">
                              </div>
                              <div class="dc-2">
                                  <h4>{{dealer?.showroom_name}}</h4>
                                  <p><span>{{dealer?.address2}},</span> {{dealer?.city}}</p>
                              </div>
                          </a>
                      </li>
                  </ul>
              </div>
          </div>
          <div class="ab-modal-footer">
            <div></div>
            <p-button label="Close" styleClass="p-button-secondary p-button-text" (onClick)="_cs.onCloseBrandStorePopup()"></p-button>
          </div>
      </div>
  </p-sidebar>
</div>
</div>
<div class="global-cart-button" (click)="openSampleCart()"  *ngIf="showSampleBtn()">
  <!-- Main Cart Button -->
  <button mat-button class="cart-main-button">
    <span class="sample-text">Sample</span>
    <i class="cart-icon fa fa-shopping-cart"></i>
    <span class="cart-count" >{{ _cart.sample_count }}</span>
  </button>
</div>

<!-- waring popup -->
<div class="success-popup">
<p-dialog   header="You Made Too Many Requests" [modal]="true" [(visible)]="_pop.isDialogVisible" [style]="{ width: '25rem' }">
  <div class="dialog-content">
    <i *ngIf="_pop.countdown" class="pi pi-clock icon"></i>
    <i style=" color: #28a745;" *ngIf="!_pop.countdown" class="pi pi-check-circle icon"></i> <!-- Updated Icon -->
    <div *ngIf="_pop.countdown">
      <p>{{ _pop.message }}</p>
      <p class="countdown">Please wait <strong>{{ _pop.countdown }}</strong> seconds before retrying.</p>
    </div>
    <div *ngIf="!_pop.countdown">
      <p>You can try again now.</p>
      <p class="retry-message">Please retry your request.</p>
    </div>


  </div>
  <ng-template pTemplate="footer">

      <button pButton label="Try Again {{_pop.countdown}}" *ngIf="_pop.countdown" icon="pi pi-check" class="p-button-warning" (click)="_pop.closeDialog()" [disabled]="_pop.countdown > 0"></button>

      <button pButton label="Try Now" icon="pi pi-check"  *ngIf="!_pop.countdown"class="p-button-warning" (click)="_pop.closeDialog()" [disabled]="_pop.countdown > 0"></button>
    
   
   
  </ng-template>
</p-dialog>
</div>
 <!-- End -->
 <!-- <div class="ab-full-width" [ngClass]="{'ab-full-wdth-shadow':!_ds.isMegaMenu}" *ngIf="isBrowser">
 <app-mega-menu></app-mega-menu>
  </div> -->


  <!-- <app-cashback-popup></app-cashback-popup>
  <app-connect-popup></app-connect-popup>
  <app-share-popup></app-share-popup>
  <app-compare-offer-popup></app-compare-offer-popup>  -->